import { createContext, useContext } from 'react';

import { invariant } from '@/lib/utils/invariant';
import type { ConsoleAuthContext } from './types';

const AuthContextValue = createContext<ConsoleAuthContext | null>(null);

export const AuthContextProvider = AuthContextValue.Provider;

export function useAuth(): ConsoleAuthContext {
    const value = useContext(AuthContextValue);
    invariant(value !== null, 'useAuth must be used inside <AuthProvider>');
    return value;
}
